import { gql } from 'apollo-angular'

export default gql`
  mutation edit_missed_phantom_test_by_pk(
    $id: Int!
    $_set: missed_phantom_test_set_input
  ) {
    update_missed_phantom_test(where: { id: { _eq: $id } }, _set: $_set) {
      affected_rows
      returning {
        id
      }
    }
  }
`
